import type { ReactNode } from 'react'
import { InfoIcon } from './icons/InfoIcon'

export interface InfoNoteProps {
  children: ReactNode
  /** Pins the note to the top of its scroll container — used by the Tenant tab's
      remote-endpoint note, which must stay visible while its operations tree scrolls. */
  sticky?: boolean
  icon?: ReactNode
  /** Single-line notes (e.g. the Tenant tab's remote-endpoint note) center the icon
      against the text, matching the prototype; the default flex-start keeps notes
      that wrap to several lines (e.g. Global Guardrails) from dropping the icon into
      the middle of the block. */
  centered?: boolean
}

export function InfoNote({ children, sticky = false, icon, centered = false }: Readonly<InfoNoteProps>) {
  return (
    <div
      className="info-note"
      style={{
        ...(centered ? { alignItems: 'center' } : undefined),
        ...(sticky ? { position: 'sticky', top: 0, zIndex: 6 } : undefined),
      }}
    >
      <span
        style={{
          color: 'var(--info)',
          flexShrink: 0,
          marginTop: centered ? 0 : 1,
          display: 'inline-flex',
        }}
      >
        {icon ?? <InfoIcon size={16} />}
      </span>
      {children}
    </div>
  )
}
